import React, { memo } from 'react'
import SubscriptionPages from './SubscriptionPages'
import styles from './settingsTabs.module.scss'

const AccountPaymentTierPage = () => {
	return (
		<div className={styles.profileCard}>
			<SubscriptionPages />
		</div>
	)
}

export default memo(AccountPaymentTierPage)
